var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-5", attrs: { cols: "12" } },
    [
      _vm.step === "viewer"
        ? [
            _c(
              "v-row",
              {
                staticClass: "ma-0 pa-0 mb-3",
                attrs: { justify: "space-between" },
              },
              [
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                  [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.tsg("selectSplitScreen")) + " : "
                        ),
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "offset-y": "",
                              "close-on-content-click": false,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "ml-2 text-none",
                                              attrs: {
                                                id: "split_screen_select_menu",
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                justify: "space-between",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass:
                                                    "ma-0 pa-0 pl-2 ellipsis",
                                                  attrs: {
                                                    cols: "11",
                                                    id: "select_menu_text",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.selectedSplitScreen
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    cols: "1",
                                                    "align-self": "end",
                                                  },
                                                },
                                                [
                                                  _c("v-img", {
                                                    attrs: {
                                                      src: require("@/assets/images/icon_arrow_down_small.png"),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1527789228
                            ),
                            model: {
                              value: _vm.splitScreenSelectMenu,
                              callback: function ($$v) {
                                _vm.splitScreenSelectMenu = $$v
                              },
                              expression: "splitScreenSelectMenu",
                            },
                          },
                          [
                            _c(
                              "v-list",
                              _vm._l(
                                _vm.splitScreenList,
                                function (item, index) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: index,
                                      attrs: { id: "select_list_item" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.closeNameChangeDialog(
                                            item.splitName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { justify: "space-between" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pl-2",
                                              attrs: {
                                                cols: "8",
                                                "align-self": "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    justify: "space-between",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "ma-0 pa-0 pr-1",
                                                      attrs: {
                                                        cols: "2",
                                                        "align-self": "center",
                                                      },
                                                    },
                                                    [
                                                      item.splitName ==
                                                      _vm.selectedSplitScreen
                                                        ? _c("v-img", {
                                                            attrs: {
                                                              src: require("@/assets/images/icon_check.png"),
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "ma-0 pa-0 ellipsis",
                                                      staticStyle: {
                                                        "text-align": "left",
                                                        "max-width": "200px",
                                                      },
                                                      attrs: { cols: "10" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.splitName
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "4" },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    id: "transparent_btn_select_small",
                                                    elevation: "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.nameChangeDialogFunc(
                                                        item.id,
                                                        item.splitName
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-img", {
                                                    attrs: {
                                                      src: require("@/assets/images/icon_pen.png"),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    id: "transparent_btn_select_small",
                                                    elevation: "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteSplit(
                                                        item.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-img", {
                                                    attrs: {
                                                      src: require("@/assets/images/close.png"),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-2",
                            attrs: { id: "blue_btn" },
                            on: { click: _vm.goCreateSplitScreen },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.tsg("createSplitScreen")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                  [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-0" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { id: "transparent_btn", elevation: "0" },
                            on: {
                              click: function ($event) {
                                _vm.splitScreenDialogVisible = true
                              },
                            },
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                src: require("@/assets/images/icon_split_screen.png"),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { id: "transparent_btn", elevation: "0" },
                            on: { click: _vm.handleFullScreen },
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                src: require("@/assets/images/video_fullscreen.png"),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            !_vm.loading
              ? _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { id: "cameras-area" } },
                  [
                    _vm.viewCount == 4
                      ? _c(
                          "v-col",
                          {
                            key: _vm.view4,
                            staticClass: "ma-0 pa-0",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-2 full-height",
                                attrs: { justify: "center" },
                              },
                              _vm._l(2, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  _vm._l(2, function (item_nest, index_nest) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: index_nest,
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c("v-hover", {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var hover = ref.hover
                                                  return [
                                                    _vm.checkSplitScreenCameraList(
                                                      index,
                                                      index_nest,
                                                      2
                                                    )
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0 ml-1 mr-1 mb-2",
                                                            attrs: {
                                                              id: "camera_4box",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_btn",
                                                                  cols: "auto",
                                                                },
                                                              },
                                                              [
                                                                hover
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          id: "hover_btn",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.showMenu(
                                                                                index_nest +
                                                                                  2 *
                                                                                    index,
                                                                                4
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: require("@/assets/images/dots.png"),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_bottom_bar",
                                                                  cols: "12",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getSplitName(
                                                                        index,
                                                                        index_nest,
                                                                        2
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            hover
                                                              ? _c(
                                                                  "SplitScreenHoverMenuList",
                                                                  {
                                                                    attrs: {
                                                                      video: "",
                                                                      group: "",
                                                                      index:
                                                                        index,
                                                                      indexCalc: 2,
                                                                      index_nest:
                                                                        index_nest,
                                                                      players:
                                                                        _vm.players,
                                                                      splitScreenCameraList:
                                                                        _vm.splitScreenCameraList,
                                                                      viewCount:
                                                                        _vm.viewCount,
                                                                      selectedSplitScreen:
                                                                        _vm.selectedSplitScreen,
                                                                      currentGroupId:
                                                                        _vm.currentGroupId,
                                                                    },
                                                                    on: {
                                                                      deleteCamera:
                                                                        _vm.deleteSplitCamera,
                                                                      openCameraSearchDialog:
                                                                        _vm.openCameraSearchDialogFunc,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "v-progress-linear",
                                                              {
                                                                attrs: {
                                                                  id:
                                                                    "example-4-progress" +
                                                                    (index_nest +
                                                                      2 *
                                                                        index),
                                                                  indeterminate:
                                                                    "",
                                                                  color: "blue",
                                                                },
                                                              }
                                                            ),
                                                            _c("video", {
                                                              staticClass:
                                                                "ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom",
                                                              staticStyle: {
                                                                "object-fit":
                                                                  "fill",
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "example-4-video" +
                                                                  (index_nest +
                                                                    2 * index),
                                                                width: "550",
                                                                height: "350",
                                                                muted: "",
                                                              },
                                                              domProps: {
                                                                muted: true,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0 ml-1 mr-1 mb-2",
                                                            attrs: {
                                                              id: "camera_4box",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_btn",
                                                                  cols: "auto",
                                                                },
                                                              },
                                                              [
                                                                hover
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          id: "hover_btn",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.showMenu(
                                                                                index_nest +
                                                                                  2 *
                                                                                    index,
                                                                                4
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: require("@/assets/images/dots.png"),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            hover
                                                              ? _c(
                                                                  "SplitScreenHoverMenuList",
                                                                  {
                                                                    attrs: {
                                                                      group: "",
                                                                      index:
                                                                        index,
                                                                      indexCalc: 2,
                                                                      index_nest:
                                                                        index_nest,
                                                                      players:
                                                                        _vm.players,
                                                                      splitScreenCameraList:
                                                                        _vm.splitScreenCameraList,
                                                                      viewCount:
                                                                        _vm.viewCount,
                                                                      selectedSplitScreen:
                                                                        _vm.selectedSplitScreen,
                                                                      currentGroupId:
                                                                        _vm.currentGroupId,
                                                                    },
                                                                    on: {
                                                                      deleteCamera:
                                                                        _vm.deleteSplitCamera,
                                                                      openCameraSearchDialog:
                                                                        _vm.openCameraSearchDialogFunc,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "v-progress-linear",
                                                              {
                                                                attrs: {
                                                                  id:
                                                                    "example-4-progress" +
                                                                    (index_nest +
                                                                      2 *
                                                                        index),
                                                                  indeterminate:
                                                                    "",
                                                                  color: "blue",
                                                                },
                                                              }
                                                            ),
                                                            _c("video", {
                                                              staticClass:
                                                                "ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom",
                                                              staticStyle: {
                                                                "object-fit":
                                                                  "fill",
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "example-4-video" +
                                                                  (index_nest +
                                                                    2 * index),
                                                                width: "550",
                                                                height: "350",
                                                                muted: "",
                                                              },
                                                              domProps: {
                                                                muted: true,
                                                              },
                                                            }),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "video_grey_box",
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                },
                                                                attrs: {
                                                                  id:
                                                                    "no-data-video" +
                                                                    (index_nest +
                                                                      2 *
                                                                        index),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.t(
                                                                        "noData"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.viewCount == 9
                      ? _c(
                          "v-col",
                          {
                            key: _vm.view9,
                            staticClass: "ma-0 pa-0",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-2 full-height",
                                attrs: { align: "center" },
                              },
                              _vm._l(3, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "4" },
                                  },
                                  _vm._l(3, function (item_nest, index_nest) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: index_nest,
                                        staticClass: "ma-0 pa-0 pr-1 pl-1 mb-2",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c("v-hover", {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var hover = ref.hover
                                                  return [
                                                    _vm.checkSplitScreenCameraList(
                                                      index,
                                                      index_nest,
                                                      3
                                                    )
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              id: "camera_9box",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_btn",
                                                                  cols: "auto",
                                                                },
                                                              },
                                                              [
                                                                hover
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          id: "hover_btn",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.showMenu(
                                                                                index_nest +
                                                                                  3 *
                                                                                    index,
                                                                                9
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: require("@/assets/images/dots.png"),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_bottom_bar",
                                                                  cols: "12",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getSplitName(
                                                                        index,
                                                                        index_nest,
                                                                        3
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            hover
                                                              ? _c(
                                                                  "SplitScreenHoverMenuList",
                                                                  {
                                                                    attrs: {
                                                                      video: "",
                                                                      group: "",
                                                                      index:
                                                                        index,
                                                                      indexCalc: 3,
                                                                      index_nest:
                                                                        index_nest,
                                                                      players:
                                                                        _vm.players,
                                                                      splitScreenCameraList:
                                                                        _vm.splitScreenCameraList,
                                                                      viewCount:
                                                                        _vm.viewCount,
                                                                      selectedSplitScreen:
                                                                        _vm.selectedSplitScreen,
                                                                      currentGroupId:
                                                                        _vm.currentGroupId,
                                                                    },
                                                                    on: {
                                                                      deleteCamera:
                                                                        _vm.deleteSplitCamera,
                                                                      openCameraSearchDialog:
                                                                        _vm.openCameraSearchDialogFunc,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "v-progress-linear",
                                                              {
                                                                attrs: {
                                                                  id:
                                                                    "example-9-progress" +
                                                                    (index_nest +
                                                                      3 *
                                                                        index),
                                                                  indeterminate:
                                                                    "",
                                                                  color: "blue",
                                                                },
                                                              }
                                                            ),
                                                            _c("video", {
                                                              staticClass:
                                                                "ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom",
                                                              staticStyle: {
                                                                "object-fit":
                                                                  "fill",
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "example-9-video" +
                                                                  (index_nest +
                                                                    3 * index),
                                                                width: "550",
                                                                height: "350",
                                                                muted: "",
                                                              },
                                                              domProps: {
                                                                muted: true,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              id: "camera_9box",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_btn",
                                                                  cols: "auto",
                                                                },
                                                              },
                                                              [
                                                                hover
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          id: "hover_btn",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.showMenu(
                                                                                index_nest +
                                                                                  3 *
                                                                                    index,
                                                                                9
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: require("@/assets/images/dots.png"),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            hover
                                                              ? _c(
                                                                  "SplitScreenHoverMenuList",
                                                                  {
                                                                    attrs: {
                                                                      group: "",
                                                                      index:
                                                                        index,
                                                                      indexCalc: 3,
                                                                      index_nest:
                                                                        index_nest,
                                                                      players:
                                                                        _vm.players,
                                                                      splitScreenCameraList:
                                                                        _vm.splitScreenCameraList,
                                                                      viewCount:
                                                                        _vm.viewCount,
                                                                      selectedSplitScreen:
                                                                        _vm.selectedSplitScreen,
                                                                      currentGroupId:
                                                                        _vm.currentGroupId,
                                                                    },
                                                                    on: {
                                                                      deleteCamera:
                                                                        _vm.deleteSplitCamera,
                                                                      openCameraSearchDialog:
                                                                        _vm.openCameraSearchDialogFunc,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "v-progress-linear",
                                                              {
                                                                attrs: {
                                                                  id:
                                                                    "example-9-progress" +
                                                                    (index_nest +
                                                                      3 *
                                                                        index),
                                                                  indeterminate:
                                                                    "",
                                                                  color: "blue",
                                                                },
                                                              }
                                                            ),
                                                            _c("video", {
                                                              staticClass:
                                                                "ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom",
                                                              staticStyle: {
                                                                "object-fit":
                                                                  "fill",
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "example-9-video" +
                                                                  (index_nest +
                                                                    3 * index),
                                                                muted: "",
                                                              },
                                                              domProps: {
                                                                muted: true,
                                                              },
                                                            }),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "video_grey_box",
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                },
                                                                attrs: {
                                                                  id:
                                                                    "no-data-video" +
                                                                    (index_nest +
                                                                      3 *
                                                                        index),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.t(
                                                                        "noData"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.viewCount == 16
                      ? _c(
                          "v-col",
                          {
                            key: _vm.view16,
                            staticClass: "ma-0 pa-0",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-2 full-height",
                                attrs: { align: "center" },
                              },
                              _vm._l(4, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "3" },
                                  },
                                  _vm._l(4, function (item_nest, index_nest) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: index_nest,
                                        staticClass: "ma-0 pa-0 pr-1 pl-1 mb-2",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c("v-hover", {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var hover = ref.hover
                                                  return [
                                                    _vm.checkSplitScreenCameraList(
                                                      index,
                                                      index_nest,
                                                      4
                                                    )
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              id: "camera_16box",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_btn",
                                                                  cols: "auto",
                                                                },
                                                              },
                                                              [
                                                                hover
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          id: "hover_btn",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.showMenu(
                                                                                index_nest +
                                                                                  4 *
                                                                                    index,
                                                                                16
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: require("@/assets/images/dots.png"),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_bottom_bar",
                                                                  cols: "12",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getSplitName(
                                                                        index,
                                                                        index_nest,
                                                                        4
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            hover
                                                              ? _c(
                                                                  "SplitScreenHoverMenuList",
                                                                  {
                                                                    attrs: {
                                                                      video: "",
                                                                      group: "",
                                                                      index:
                                                                        index,
                                                                      indexCalc: 4,
                                                                      index_nest:
                                                                        index_nest,
                                                                      players:
                                                                        _vm.players,
                                                                      splitScreenCameraList:
                                                                        _vm.splitScreenCameraList,
                                                                      viewCount:
                                                                        _vm.viewCount,
                                                                      selectedSplitScreen:
                                                                        _vm.selectedSplitScreen,
                                                                      currentGroupId:
                                                                        _vm.currentGroupId,
                                                                    },
                                                                    on: {
                                                                      deleteCamera:
                                                                        _vm.deleteSplitCamera,
                                                                      openCameraSearchDialog:
                                                                        _vm.openCameraSearchDialogFunc,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "v-progress-linear",
                                                              {
                                                                attrs: {
                                                                  id:
                                                                    "example-16-progress" +
                                                                    (index_nest +
                                                                      4 *
                                                                        index),
                                                                  indeterminate:
                                                                    "",
                                                                  color: "blue",
                                                                },
                                                              }
                                                            ),
                                                            _c("video", {
                                                              staticClass:
                                                                "ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom",
                                                              staticStyle: {
                                                                "object-fit":
                                                                  "fill",
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "example-16-video" +
                                                                  (index_nest +
                                                                    4 * index),
                                                                width: "550",
                                                                height: "350",
                                                                muted: "",
                                                              },
                                                              domProps: {
                                                                muted: true,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              id: "camera_16box",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "camera_select_btn",
                                                                  cols: "auto",
                                                                },
                                                              },
                                                              [
                                                                hover
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          id: "hover_btn",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.showMenu(
                                                                                index_nest +
                                                                                  4 *
                                                                                    index,
                                                                                16
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: require("@/assets/images/dots.png"),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            hover
                                                              ? _c(
                                                                  "SplitScreenHoverMenuList",
                                                                  {
                                                                    attrs: {
                                                                      group: "",
                                                                      index:
                                                                        index,
                                                                      indexCalc: 4,
                                                                      index_nest:
                                                                        index_nest,
                                                                      players:
                                                                        _vm.players,
                                                                      splitScreenCameraList:
                                                                        _vm.splitScreenCameraList,
                                                                      viewCount:
                                                                        _vm.viewCount,
                                                                      selectedSplitScreen:
                                                                        _vm.selectedSplitScreen,
                                                                      currentGroupId:
                                                                        _vm.currentGroupId,
                                                                    },
                                                                    on: {
                                                                      deleteCamera:
                                                                        _vm.deleteSplitCamera,
                                                                      openCameraSearchDialog:
                                                                        _vm.openCameraSearchDialogFunc,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "v-progress-linear",
                                                              {
                                                                attrs: {
                                                                  id:
                                                                    "example-16-progress" +
                                                                    (index_nest +
                                                                      4 *
                                                                        index),
                                                                  indeterminate:
                                                                    "",
                                                                  color: "blue",
                                                                },
                                                              }
                                                            ),
                                                            _c("video", {
                                                              staticClass:
                                                                "ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom",
                                                              staticStyle: {
                                                                "object-fit":
                                                                  "fill",
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "example-16-video" +
                                                                  (index_nest +
                                                                    4 * index),
                                                                muted: "",
                                                              },
                                                              domProps: {
                                                                muted: true,
                                                              },
                                                            }),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "video_grey_box",
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                },
                                                                attrs: {
                                                                  id:
                                                                    "no-data-video" +
                                                                    (index_nest +
                                                                      4 *
                                                                        index),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.t(
                                                                        "noData"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0" },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-10 mt-10",
                        attrs: { cols: "12", align: "center" },
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: {
                            indeterminate: "",
                            color: "white",
                            width: 6,
                            size: 50,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]
        : _vm.step === "select"
        ? [
            _c(
              "v-col",
              {
                staticClass: "ma-0 pa-0",
                attrs: { cols: "12", align: "center" },
              },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "ma-0 pa-0 mt-10",
                    attrs: { cols: "12", id: "group_box" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-2",
                        attrs: { cols: "12", id: "group_box_title" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.tsg("selectSplitScreenLayout")) + " "
                        ),
                        _vm.splitScreenList.length > 0
                          ? _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { id: "close_btn", cols: "auto" },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 back_clean_btn",
                                    attrs: {
                                      width: "2rem",
                                      height: "2rem",
                                      elevation: "0",
                                    },
                                    on: { click: _vm.backToViewer },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/popup_close.png"),
                                        id: "btn_img",
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pt-6 pb-6 pl-15 pr-15",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pt-9 pb-9",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "4" },
                              },
                              [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mb-4",
                                  attrs: {
                                    "max-height": "6rem",
                                    "max-width": "8rem",
                                    src: require("@/assets/images/4view.png"),
                                  },
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 pl-2 pr-2",
                                    attrs: {
                                      width: "8rem",
                                      height: "2rem",
                                      id: "blue_btn",
                                      elevation: "0",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.chooseLayout(4)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "4" +
                                            _vm.tsg("createdLayoutWithCameras")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "4" },
                              },
                              [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mb-4",
                                  attrs: {
                                    "max-height": "6rem",
                                    "max-width": "8rem",
                                    src: require("@/assets/images/9view.png"),
                                  },
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 pl-2 pr-2",
                                    attrs: {
                                      width: "8rem",
                                      height: "2rem",
                                      id: "blue_btn",
                                      elevation: "0",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.chooseLayout(9)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "9" +
                                            _vm.tsg("createdLayoutWithCameras")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "4" },
                              },
                              [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mb-4",
                                  attrs: {
                                    "max-height": "6rem",
                                    "max-width": "8rem",
                                    src: require("@/assets/images/16view.png"),
                                  },
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 pl-2 pr-2",
                                    attrs: {
                                      width: "8rem",
                                      height: "2rem",
                                      id: "blue_btn",
                                      elevation: "0",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.chooseLayout(16)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "16" +
                                            _vm.tsg("createdLayoutWithCameras")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm.step === "cameraSelect"
        ? [
            _vm.viewCount == 4
              ? _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                  [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-2", attrs: { align: "center" } },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 pr-2",
                            attrs: { cols: "6", align: "right" },
                          },
                          _vm._l(2, function (item, index) {
                            return _c(
                              "v-col",
                              {
                                key: index,
                                staticClass:
                                  "slot_box split_4box ma-0 pa-0 mb-4",
                                attrs: { cols: "12" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cameraSelect(index)
                                  },
                                },
                              },
                              [
                                _vm.slotCameras[index]
                                  ? [
                                      _vm.slotCameras[index].thumbnailSrc
                                        ? _c("v-img", {
                                            staticClass: "slot_img",
                                            attrs: {
                                              src: _vm.slotCameras[index]
                                                .thumbnailSrc,
                                              height: "100%",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "slot_name ellipsis" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.slotCameras[index].cameraName
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          width: "9rem",
                                          height: "2rem",
                                          id: "blue_btn",
                                          elevation: "0",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.tsg("selectCamera")))]
                                    ),
                              ],
                              2
                            )
                          }),
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 pl-2",
                            attrs: { cols: "6", align: "left" },
                          },
                          _vm._l(2, function (item, index) {
                            return _c(
                              "v-col",
                              {
                                key: index,
                                staticClass:
                                  "slot_box split_4box ma-0 pa-0 mb-4",
                                attrs: { cols: "12" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cameraSelect(index + 2)
                                  },
                                },
                              },
                              [
                                _vm.slotCameras[index + 2]
                                  ? [
                                      _vm.slotCameras[index + 2].thumbnailSrc
                                        ? _c("v-img", {
                                            staticClass: "slot_img",
                                            attrs: {
                                              src: _vm.slotCameras[index + 2]
                                                .thumbnailSrc,
                                              height: "100%",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "slot_name ellipsis" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.slotCameras[index + 2]
                                                .cameraName
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          width: "9rem",
                                          height: "2rem",
                                          id: "blue_btn",
                                          elevation: "0",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.tsg("selectCamera")))]
                                    ),
                              ],
                              2
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.viewCount == 9
              ? _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                  [
                    _c(
                      "v-row",
                      {
                        staticClass: "ma-0 pa-0 pl-1 pr-1",
                        attrs: { align: "center" },
                      },
                      _vm._l(3, function (item, index) {
                        return _c(
                          "v-col",
                          {
                            key: index,
                            staticClass: "ma-0 pa-0 pr-1 pl-1",
                            attrs: { cols: "4" },
                          },
                          _vm._l(3, function (item_nest, index_nest) {
                            return _c(
                              "v-col",
                              {
                                key: index_nest,
                                staticClass:
                                  "slot_box split_9box ma-0 pa-0 mb-2",
                                attrs: { cols: "12" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cameraSelect(
                                      index_nest + 3 * index
                                    )
                                  },
                                },
                              },
                              [
                                _vm.slotCameras[index_nest + 3 * index]
                                  ? [
                                      _vm.slotCameras[index_nest + 3 * index]
                                        .thumbnailSrc
                                        ? _c("v-img", {
                                            staticClass: "slot_img",
                                            attrs: {
                                              src: _vm.slotCameras[
                                                index_nest + 3 * index
                                              ].thumbnailSrc,
                                              height: "100%",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "slot_name ellipsis" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.slotCameras[
                                                index_nest + 3 * index
                                              ].cameraName
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          width: "9rem",
                                          height: "2rem",
                                          id: "blue_btn",
                                          elevation: "0",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.tsg("selectCamera")))]
                                    ),
                              ],
                              2
                            )
                          }),
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.viewCount == 16
              ? _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                  [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-2", attrs: { align: "center" } },
                      _vm._l(4, function (item, index) {
                        return _c(
                          "v-col",
                          {
                            key: index,
                            staticClass: "ma-0 pa-0 pl-1 pr-1",
                            attrs: { cols: "3" },
                          },
                          _vm._l(4, function (item_nest, index_nest) {
                            return _c(
                              "v-col",
                              {
                                key: index_nest,
                                staticClass:
                                  "slot_box split_16box ma-0 pa-0 mb-2",
                                attrs: { cols: "12" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cameraSelect(
                                      index_nest + 4 * index
                                    )
                                  },
                                },
                              },
                              [
                                _vm.slotCameras[index_nest + 4 * index]
                                  ? [
                                      _vm.slotCameras[index_nest + 4 * index]
                                        .thumbnailSrc
                                        ? _c("v-img", {
                                            staticClass: "slot_img",
                                            attrs: {
                                              src: _vm.slotCameras[
                                                index_nest + 4 * index
                                              ].thumbnailSrc,
                                              height: "100%",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "slot_name ellipsis" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.slotCameras[
                                                index_nest + 4 * index
                                              ].cameraName
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          width: "8rem",
                                          height: "2rem",
                                          id: "blue_btn",
                                          elevation: "0",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.tsg("selectCamera")))]
                                    ),
                              ],
                              2
                            )
                          }),
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "v-col",
              { staticClass: "ma-0 pa-0 mt-3 mb-7", attrs: { cols: "12" } },
              [
                _c(
                  "v-row",
                  {
                    staticClass: "ma-0 pa-0",
                    attrs: { align: "center", justify: "center" },
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          width: "9rem",
                          height: "2rem",
                          id: "grey_btn",
                          elevation: "0",
                        },
                        on: { click: _vm.backToSelect },
                      },
                      [_vm._v(_vm._s(_vm.t("cancel")))]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ma-0 pa-0 ml-3",
                        attrs: {
                          width: "9rem",
                          height: "2rem",
                          id: "blue_btn",
                          elevation: "0",
                          loading: _vm.createLoading,
                        },
                        on: { click: _vm.createSplit },
                      },
                      [_vm._v(_vm._s(_vm.t("create")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c("CameraGroupSplitCameraDialog", {
        attrs: {
          dialogVisible: _vm.cameraSearchDialogVisible,
          cameras: _vm.groupCameras,
        },
        on: {
          visible: _vm.cameraSearchDialogVisibleFunc,
          selectedCamera: _vm.onPickerSelect,
        },
      }),
      _c("NameChangeDialog", {
        attrs: {
          dialogVisible: _vm.nameChangeDialogVisible,
          editType: _vm.editNameType,
          currentId: _vm.currentId,
          currentName: _vm.currentName,
        },
        on: {
          nameUpdate: _vm.nameUpdateFunc,
          visible: _vm.nameChangeDialogVisibleFunc,
        },
      }),
      _c("SplitScreenDialog", {
        attrs: {
          dialogVisible: _vm.splitScreenDialogVisible,
          viewCount: _vm.viewCount,
        },
        on: {
          visible: _vm.splitScreenDialogVisibleFunc,
          selectedViewCount: _vm.selectedViewCountFunc,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }